import React, { useEffect, useState, JSX } from 'react';
import { useParams } from 'react-router-dom';
import { Textarea } from "@/components/ui/textarea";
import { getAuthUID, isAuthLoaded, onAuthReady } from '@/lib/authState';
import { useTenancy } from '@/contexts/TenancyContext';
import { useUser } from "@/contexts/UserContextProvider";

import { DataTable } from '@/components/ui/datatable';
import { getPrivacyRequestColumns } from './components/columns';

import {
  addPrivacyRequestNote,
  changePrivacyRequestItemStatus,
  createEmptyPrivacyRequestsItem,
  createPrivacyRequestItem,
  deletePrivacyRequestItem,
  delPrivacyRequestNote,
  getPrivacyRequestList,
  PrivacyRequestNote,
  PrivacyRequestsItem, updatePrivacyRequestItem
} from '@/services/privacyRequestTracker';

import { ScrollArea } from "@/components/ui/scroll-area"

import { Button } from '@/components/ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import {
  Dialog,
  DialogClose,
  DialogContent,
} from "@/components/ui/dialog"
import { TOUR_STEP_IDS } from '@/lib/tour-constants';
import { TourAlertDialog, useTour } from '@/components/tour';
import {
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"

import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer"

import { useIsMobile } from "@/hooks/use-mobile"

import { toast } from 'sonner';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNotes, faCheck, faXmark, faRepeat, faCheckToSlot } from '@awesome.me/kit-269fbef2e2/icons/duotone/solid';

import { Timestamp as FirebaseTimestamp } from 'firebase/firestore';
import { AlertTriangle, Plus, Search, Upload } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import HelpPopoverHover from '@/components/HelpPopoverHover';
import { colorValues, useTheme } from '@/contexts/ThemeContext';
import { getHelpContentByPage } from '@/services/HelpPopoverService';
import { useAuth } from '@/contexts/AuthContext';
import { DatePicker } from '@/components/ui/date-picker';

import { ChevronDownIcon } from "lucide-react"
import { Calendar } from "@/components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

import { read as readRequest, update as updateRequest, remove as removeRequest, create as createRequest,
  PrivacyRequestWithId, PrivacyRequestDocCreateSchema, type PrivacyRequestCreateDoc
} from '@/services/privacyRequestTrackerV2';
import { read as readNote, update as updateNote, create as createNote, remove as removeNote } from '@/services/privacyRequestTrackerNoteV2';
import type { PrivacyRequestTrackerNoteDocWithId } from '@/services/privacyRequestTrackerNoteV2';

import * as z from 'zod/v4';
import { renderDate } from '../../../../shared/renderDate';

interface PrivacyRegisterNewItemProps {
  isOpen: boolean;
  onClose?: () => void;
  onActions?: {
    onCreate?: () => void;
  }
}
const PrivacyRegisterNewItem = ({ isOpen, onClose, onActions }: PrivacyRegisterNewItemProps) => {
  const { activeTenancy, userIdToName } = useTenancy();
  const { user } = useAuth();

  const { isDark, primaryColor, accentColor } = useTheme();
  const primaryColorValue = colorValues[primaryColor]?.primary || colorValues.default.primary;

  //Form things
  const [formState, setFormState] = useState<PrivacyRequestCreateDoc>({
    email: '',
    name: '',
    phone: '',
    message: '',
    status: 'Open',
  });
  const [formErrors, setFormErrors] = useState<PrivacyRequestCreateDoc>({
    email: '',
    name: '',
    phone: '',
    message: '',
    status: 'Open',
  });

  const validateForm = () => {
    const zResult = PrivacyRequestDocCreateSchema.safeParse(formState);

    if (zResult.success) return {
      email: '',
      name: '',
      phone: '',
      message: '',
    };

    const { fieldErrors } = z.flattenError(zResult.error)

    return {
      email: fieldErrors.email?.[0] ?? "",
      name: fieldErrors.name?.[0] ?? "",
      phone: fieldErrors.phone?.[0] ?? "",
      message: fieldErrors.message?.[0] ?? "",
    };
  }

  const [errorMessage, setErrorMessage] = useState<string>(null);
  const handleChange = (field: keyof typeof formState, value: string) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
    setFormErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const [isSubmitting, setSubmitting] = useState(false);

  // Handle the submit trigger
  const handleSubmit = async () => {
    // const formData = {
    //   name: formState.name ? '' : 'Required',
    //   email: formState.email ? '' : 'Required',
    //   phoneNumber: formState.phoneNumber ? '' : 'Required',
    //   typeOfRequest: formState.typeOfRequest ? '' : 'Required',
    // };
    //
    // setFormErrors(formData);
    const formErrors = validateForm(formState);
    console.log('asd', formErrors);
    setFormErrors(formErrors);
    if (Object.values(formErrors).some(Boolean)) return;

    // setSubmitting(true);

    console.log(user, activeTenancy)

    const res = await createRequest(activeTenancy.id, formState);

    if (!res) {
      toast.error(res.message);
      setSubmitting(false);
      setErrorMessage(res.message);
    }


    await createNote(activeTenancy.id, res, {
      owner: '0',
      message: 'Request created using the Privacy Register.',
    });

    toast.success('Privacy request created!');
    setSubmitting(false);
    onClose();
  }

  // Reset the form
  useEffect(() => {
    setFormState(createEmptyPrivacyRequestsItem());
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose} >
      <DialogContent className={`max-w-2xl ${isDark ? 'dark bg-background' : 'bg-white'}`} aria-describedby={undefined} onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle className="text-foreground">Create New Privacy Request</DialogTitle>
        </DialogHeader>

        <div className="grid gap-4 py-4">
          {errorMessage && (
            <div className={`border px-4 py-3 rounded flex items-start ${isDark ? 'bg-red-900/20 border-red-800 text-red-400' : 'bg-red-50 border-red-200 text-red-700'}`}>
              <AlertTriangle className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5" />
              <p>{errorMessage}</p>
            </div>
          )}
          <div className="grid grid-cols-3 items-center gap-4">
            <Label htmlFor="policy-name" className="text-right text-sm font-medium text-foreground">
              Name
            </Label>
            <Input
              id="name"
              value={formState.name}
              onChange={(e) => handleChange('name', e.target.value)}
              required
              className={`col-span-2 border rounded-md focus:ring-1
              ${formErrors.name
                ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
              }`}
            />
            {formErrors.name && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.name}</p>}
          </div>
          <div className="grid grid-cols-3 items-center gap-4">
            <Label htmlFor="policy-name" className="text-right text-sm font-medium text-foreground">
              Email
            </Label>
            <Input
              id="email"
              value={formState.email}
              onChange={(e) => handleChange('email', e.target.value)}
              required
              className={`col-span-2 border rounded-md focus:ring-1
              ${formErrors.email
                ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
              }`}
            />
            {formErrors.email && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.email}</p>}
          </div>
          <div className="grid grid-cols-3 items-center gap-4">
            <Label htmlFor="policy-name" className="text-right text-sm font-medium text-foreground">
              Phone
            </Label>
            <Input
              id="phoneNumber"
              value={formState.phone}
              onChange={(e) => handleChange('phone', e.target.value)}
              required
              className={`col-span-2 border rounded-md focus:ring-1
              ${formErrors.phone
                ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
              }`}
            />
            {formErrors.phone && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.phone}</p>}
          </div>
          <div className="grid grid-cols-3 items-center gap-4">
            <Label htmlFor="policy-name" className="text-right text-sm font-medium text-foreground">
              Details
            </Label>
            <Textarea
              id="typeOfRequest"
              value={formState.message}
              onChange={(e) => handleChange('message', e.target.value)}
              required
              className={`col-span-2 border rounded-md focus:ring-1
              ${formErrors.message
                ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
              }`}
            />
            {formErrors.message && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.message}</p>}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className={`border ${isDark ? 'border-border hover:bg-accent/10' : 'border-gray-200 hover:bg-gray-50 hover:text-gray-700'}`} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} style={{ background: primaryColorValue }} disabled={isSubmitting}>
            {isSubmitting ? 'Saving...' : 'Save Changes'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
};

interface PrivacyRegisterViewItemProps {
  isOpen: boolean;
  onClose: () => void;
  privacyRequest: PrivacyRequestWithId;
  reload: () => void;
}
const PrivacyItemViewItemDialog = ({ isOpen, onClose, privacyRequest, reload }: PrivacyRegisterViewItemProps) => {
  const { activeTenancy, userIdToName } = useTenancy();
  const { user } = useAuth()
  const isMobile = useIsMobile();

  const { isDark, primaryColor, accentColor } = useTheme();

  const [formState, setFormState] = useState<PrivacyRequestWithId>(null);
  const [formErrors, setFormErrors] = useState<PrivacyRequestWithId>(createEmptyPrivacyRequestsItem());
  const [errorMessage, setErrorMessage] = useState<string>(null);

  const [changesMade, setChangesMade] = useState<boolean>(false);
  const [showAddNote, setShowAddNote] = useState<boolean>(false);
  const [notes, setNotes] = useState<PrivacyRequestTrackerNoteDocWithId[]>([]);
  const [activeTab, setActiveTab] = useState<'details' | 'notes'>('details');

  const [newNoteText, setNewNoteText] = useState<string>('');
  const [processingRequest, setProcessingRequest] = useState<boolean>(false);

  const [openDate, setOpenDate] = React.useState(false)


  const handleChange = (field: keyof typeof formState, value: string) => {
    setChangesMade(true);
    console.log(field, formState, value);
    setFormState((prev) => ({ ...prev, [field]: value }));
    setFormErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const computeAvailableStatuses = (status: string) => {
    switch (status.toLowerCase()) {
      case 'open': return [
        { display: 'Accept', value: 'Active' },
        { display: 'Close', value: 'Closed' },
      ];

      case 'active': return [
        { display: 'Close', value: 'Closed' },
      ];

      case 'completed':
      case 'closed': return [
        { display: 'Re-open', value: 'Open' },
      ];
    }
  };

  const handleSaveChanges = () => {
    const updated = updateRequest(activeTenancy.id, formState);

    if (updated) {
      toast.success('Successfully updated!');
      setChangesMade(false);
      reload();
    } else {
      toast.error('There was an issue saving..');
    }
  };

  const handleAddNote = async () => {
    if (newNoteText.trim() === '') { console.warn('Unable to add empty note!'); return; }

    const payload = {
      owner: user.uid,
      message: newNoteText,
      metadata: {
        created_at: new Date(),
        deleted_at: null,
      }
    };

    console.log(activeTenancy.id, privacyRequest, payload)
    const result = await createNote(activeTenancy.id, privacyRequest, payload);

    if (result) {
      toast.success('Successfully added!');

      reload(); // Reload DataTable

      // Hide and reload form
      setShowAddNote(false)
      setNewNoteText('');
      setProcessingRequest(false);

      readNote(activeTenancy.id, privacyRequest).then((notes) => {
        setNotes(notes);
        console.log('asdd', 'notes', notes)
      });

    } else {
      toast.error('There was an issue adding the note');
    }
  };

  const handleDeleteNote = async (note: PrivacyRequestTrackerNoteDocWithId) => {
    console.log(activeTenancy, formState, note);
    // const result = await delPrivacyRequestNote(activeTenancy, formState, note);

    console.log('asd', activeTenancy.id, privacyRequest, note);
    const result = await removeNote(activeTenancy.id, privacyRequest, note);

    if (result) {
      toast.success('Successfully deleted!');
      setNotes(prev => prev.filter(n => n.id !== note.id));
    } else {
      toast.error('There was an issue deleting the note');
    }
  }

  useEffect(() => {
    if (!privacyRequest || !privacyRequest.id) return;
    setFormState(privacyRequest)
    setChangesMade(false)

    readNote(activeTenancy.id, privacyRequest).then((notes) => {
      setNotes(notes);
      console.log('asdd', 'notes', notes)
    });

    console.log('setFormState', privacyRequest, activeTenancy.id, privacyRequest.id);
  }, [isOpen]);

  if(!privacyRequest || formState == null) return null;

  const dateToTimeString = (date: Date) => {
    const h = String(date.getHours()).padStart(2, "0");
    const m = String(date.getMinutes()).padStart(2, "0");
    const s = String(date.getSeconds()).padStart(2, "0");
    return `${h}:${m}:${s}`;
  }

  const applyTimeToDate = (date: Date, time: string) => {
    const [h, m, s] = time.split(":").map(Number);
    const newDate = new Date(date);
    newDate.setHours(h, m, s ?? 0, 0);
    return newDate;
  }

  // Mobile drawer version
  if (isMobile) {
    return (
      <Drawer open={isOpen} onOpenChange={onClose}>
        <DrawerContent className="bg-card">
          <DrawerHeader>
            <DrawerTitle>Privacy Request</DrawerTitle>
            <DrawerDescription>ID: {privacyRequest.friendly_id}</DrawerDescription>
          </DrawerHeader>

          {/* Tab Navigation */}
          <div className="px-4">
            <div className="flex space-x-1 border-b">
              <button
                className={`flex-1 pb-2 px-1 text-sm font-medium border-b-2 transition-colors ${
                  activeTab === 'details'
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:text-foreground'
                }`}
                onClick={() => setActiveTab('details')}
              >
                Details
              </button>
              <button
                className={`flex-1 pb-2 px-1 text-sm font-medium border-b-2 transition-colors ${
                  activeTab === 'notes'
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:text-foreground'
                }`}
                onClick={() => setActiveTab('notes')}
              >
                Notes ({formState.notes?.length || 0})
              </button>
            </div>
          </div>

          <div className="px-4 pb-4">
            {errorMessage && (
              <div className={`border px-4 py-3 rounded flex items-start ${isDark ? 'bg-red-900/20 border-red-800 text-red-400' : 'bg-red-50 border-red-200 text-red-700'}`}>
                <AlertTriangle className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5" />
                <p>{errorMessage}</p>
              </div>
            )}

            {/* Details Tab */}
            {activeTab === 'details' && (
              <div className="space-y-4 pt-4">
                <div>
                  <Label htmlFor="policy-status" className="text-sm font-medium text-foreground mb-2 block">
                    Status
                  </Label>
                  <Select defaultValue={formState.status} onValueChange={(value) => handleChange('status', value)}>
                    <SelectTrigger className="w-full">
                      <SelectValue placeholder={privacyRequest.status} />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectItem className="hover:!bg-primary/20 transition-colors data-[highlighted]:bg-primary/20" value={privacyRequest.status}>{privacyRequest.status}</SelectItem>
                        {computeAvailableStatuses(privacyRequest.status).map((status) => (
                          <SelectItem className="hover:!bg-primary/20 transition-colors data-[highlighted]:bg-primary/20" value={status.value}>{status.display}</SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>

                <div>
                  <Label htmlFor="policy-name" className="text-sm font-medium text-foreground mb-2 block">
                    Name
                  </Label>
                  <Input
                    id="name"
                    value={formState.name}
                    onChange={(e) => handleChange('name', e.target.value)}
                    required
                    className={`border rounded-md focus:ring-1
                    ${formErrors.name
                      ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                      : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
                    }`}
                  />
                  {formErrors.name && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.name}</p>}
                </div>

                <div>
                  <Label htmlFor="policy-email" className="text-sm font-medium text-foreground mb-2 block">
                    Email
                  </Label>
                  <Input
                    id="email"
                    value={formState.email}
                    onChange={(e) => handleChange('email', e.target.value)}
                    required
                    className={`border rounded-md focus:ring-1
                    ${formErrors.email
                      ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                      : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
                    }`}
                  />
                  {formErrors.email && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.email}</p>}
                </div>

                <div>
                  <Label htmlFor="policy-phone" className="text-sm font-medium text-foreground mb-2 block">
                    Phone
                  </Label>
                  <Input
                    id="phoneNumber"
                    value={formState.phone}
                    onChange={(e) => handleChange('phoneNumber', e.target.value)}
                    required
                    className={`border rounded-md focus:ring-1
                    ${formErrors.phone
                      ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                      : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
                    }`}
                  />
                  {formErrors.phone && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.phone}</p>}
                </div>

                <div>
                  <Label htmlFor="policy-details" className="text-sm font-medium text-foreground mb-2 block">
                    Details
                  </Label>
                  <Textarea
                    id="typeOfRequest"
                    value={formState.typeOfRequest}
                    onChange={(e) => handleChange('typeOfRequest', e.target.value)}
                    required
                    className={`border rounded-md focus:ring-1
                    ${formErrors.typeOfRequest
                      ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                      : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
                    }`}
                  />
                  {formErrors.typeOfRequest && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.typeOfRequest}</p>}
                </div>
              </div>
            )}

            {/* Notes Tab */}
            {activeTab === 'notes' && (
              <div className="pt-4">
                <div className="space-y-4">
                  {!showAddNote && (
                    <Button variant="outline" className="w-full" onClick={() => setShowAddNote(true)}>
                      Add Note
                    </Button>
                  )}

                  {showAddNote && (
                    <div className="space-y-3">
                      <Textarea
                        placeholder="Add a note..."
                        className="w-full"
                        rows={4}
                        value={newNoteText}
                        onChange={(e) => setNewNoteText(e.target.value)}
                      />
                      <div className="flex justify-end space-x-2">
                        <Button variant="outline" onClick={() => {setShowAddNote(false); setNewNoteText('');}}>
                          Cancel
                        </Button>
                        <Button disabled={processingRequest} size={'sm'} onClick={() => handleAddNote()}>
                          Save
                        </Button>
                      </div>
                    </div>
                  )}

                  <ScrollArea className="h-80">
                    {notes?.length > 0 ? (
                      notes.reverse().map((note, index) => (
                        <div key={index} className="border p-4 rounded-md mt-2">
                          <p className="text-sm whitespace-pre-wrap">{note.message}</p>
                          <p className="text-xs text-muted-foreground pt-2">
                            — {note.metadata.author.name} on {note.metadata.date.toDate().toLocaleString()}
                          </p>
                          <div className="flex justify-end">
                            <AlertDialog>
                              <AlertDialogTrigger asChild>
                                <Button disabled={processingRequest} className="mt-2" variant="destructive" size="xs">
                                  Remove
                                </Button>
                              </AlertDialogTrigger>
                              <AlertDialogContent className="bg-white">
                                <AlertDialogHeader>
                                  <AlertDialogTitle>Are you sure?</AlertDialogTitle>
                                  <AlertDialogDescription>
                                    This will permanently remove the note. This action cannot be undone.
                                  </AlertDialogDescription>
                                </AlertDialogHeader>
                                <AlertDialogFooter>
                                  <AlertDialogCancel>Cancel</AlertDialogCancel>
                                  <AlertDialogAction asChild>
                                    <Button variant="destructive" className="bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60" onClick={() => {
                                      console.log(note);
                                      handleDeleteNote(note);
                                    }}>Delete</Button>
                                  </AlertDialogAction>
                                </AlertDialogFooter>
                              </AlertDialogContent>
                            </AlertDialog>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center text-muted-foreground py-8">
                        <p>No current notes</p>
                      </div>
                    )}
                  </ScrollArea>
                </div>
              </div>
            )}
          </div>

          <DrawerFooter>
            <Button variant="default" className="w-full" disabled={!changesMade} onClick={handleSaveChanges}>
              {changesMade ? 'Save Changes' : 'No changes made'}
            </Button>
            <DrawerClose asChild>
              <Button variant="outline" className="w-full">
                Close
              </Button>
            </DrawerClose>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    );
  }


  // Desktop dialog version
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-4xl min-h-[500px] max-w-4xl bg-secondary">
        <div className="flex">
          {/* Left side - Finding Details */}
          <div className="w-1/2 pr-6 border-r">
            <DialogHeader>
              <DialogTitle>Privacy Request</DialogTitle>
              <DialogDescription>PRT-{privacyRequest.friendly_id}</DialogDescription>
            </DialogHeader>

            <div className="grid gap-4 py-4">
              {errorMessage && (
                <div className={`border px-4 py-3 rounded flex items-start ${isDark ? 'bg-red-900/20 border-red-800 text-red-400' : 'bg-red-50 border-red-200 text-red-700'}`}>
                  <AlertTriangle className="h-5 w-5 mr-2 flex-shrink-0 mt-0.5" />
                  <p>{errorMessage}</p>
                </div>
              )}
              <div className="grid grid-cols-3 items-center gap-4 w-full">
                <Label htmlFor="policy-status" className="text-right text-sm font-medium text-foreground">
                  Status
                </Label>
                <div className="col-span-2">
                <Select defaultValue={formState.status} onValueChange={(value) => handleChange('status', value)}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder={privacyRequest.status} />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem className="hover:!bg-primary/20 transition-colors data-[highlighted]:bg-primary/20" value={privacyRequest.status}>{privacyRequest.status}</SelectItem>
                      {computeAvailableStatuses(privacyRequest.status).map((status) => (
                        <SelectItem className="hover:!bg-primary/20 transition-colors data-[highlighted]:bg-primary/20" value={status.value}>{status.display}</SelectItem>
                      ))}
                    </SelectGroup>
                  </SelectContent>
                </Select>
                </div>
              </div>
              <div className="grid grid-cols-3 items-center gap-4">
                <Label htmlFor="policy-name" className="text-right text-sm font-medium text-foreground">
                  Name
                </Label>
                <Input
                  id="name"
                  value={formState.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  required
                  className={`col-span-2 border rounded-md focus:ring-1
              ${formErrors.name
                    ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                    : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
                  }`}
                />
                {formErrors.name && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.name}</p>}
              </div>
              <div className="grid grid-cols-3 items-center gap-4">
                <Label htmlFor="policy-name" className="text-right text-sm font-medium text-foreground">
                  Email
                </Label>
                <Input
                  id="email"
                  value={formState.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  required
                  className={`col-span-2 border rounded-md focus:ring-1
              ${formErrors.email
                    ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                    : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
                  }`}
                />
                {formErrors.email && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.email}</p>}
              </div>
              <div className="grid grid-cols-3 items-center gap-4">
                <Label htmlFor="policy-name" className="text-right text-sm font-medium text-foreground">
                  Phone
                </Label>
                <Input
                  id="phoneNumber"
                  value={formState.phone}
                  onChange={(e) => handleChange('phone', e.target.value)}
                  required
                  className={`col-span-2 border rounded-md focus:ring-1
              ${formErrors.phone
                    ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                    : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
                  }`}
                />
                {formErrors.phone && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.phone}</p>}
              </div>
              <div className="grid grid-cols-3 items-center gap-4">
                <Label htmlFor="policy-name" className="text-right text-sm font-medium text-foreground">
                  Details
                </Label>
                <Textarea
                  id="typeOfRequest"
                  value={formState.message}
                  onChange={(e) => handleChange('message', e.target.value)}
                  required
                  className={`col-span-2 border rounded-md focus:ring-1
              ${formErrors.message
                    ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
                    : isDark ? 'dark:border-border dark:focus:border-primary dark:focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
                  }`}
                />
                {formErrors.message && <p className={`text-sm ${isDark ? 'text-red-400' : 'text-red-500'}`}>{formErrors.message}</p>}
              </div>
              <div className="grid grid-cols-3 items-center gap-4">
                <Label htmlFor="date-picker" className="px-1">
                  Created
                </Label>
                <Popover open={openDate} onOpenChange={setOpenDate}>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      id="date-picker"
                      className="w-32 justify-between font-normal"
                    >
                      {formState.metadata.created_at ? formState.metadata.created_at.toLocaleDateString() : "Select date"}
                      <ChevronDownIcon />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto overflow-hidden p-0" align="start">
                    <Calendar
                      mode="single"
                      selected={formState.metadata.created_at}
                      captionLayout="dropdown"
                      onSelect={(date) => {
                        if (!date) return; // calendar can pass undefined

                        setOpenDate(false);

                        setFormState(prev => {
                          const prevDate = prev.metadata.created_at ?? new Date();

                          // clone the selected date
                          const newDate = new Date(date)

                          // copy time from previous date
                          newDate.setHours(
                            prevDate.getHours(),
                            prevDate.getMinutes(),
                            prevDate.getSeconds(),
                            prevDate.getMilliseconds()
                          );

                          return {
                            ...prev,
                            metadata: {
                              ...prev.metadata,
                              created_at: newDate,
                            },
                          };
                        });
                        setChangesMade(true);
                      }}
                    />
                  </PopoverContent>
                </Popover>
                <Input
                  type="time"
                  id="time-picker"
                  step="1"
                  value={
                    formState.metadata.created_at
                      ? dateToTimeString(formState.metadata.created_at)
                      : "00:00:00"
                  }
                  onChange={(e) => {
                    const newTime = e.target.value;

                    setFormState(prev => ({
                      ...prev,
                      metadata: {
                        ...prev.metadata,
                        created_at: applyTimeToDate(prev.metadata.created_at, newTime),
                      },
                    }));
                    setChangesMade(true);
                  }}
                  className="bg-background appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none"
                />

              </div>
            </div>


            <div className="mt-6">
              <Button variant="default" className="w-full" disabled={!changesMade} onClick={handleSaveChanges}>
                {changesMade ? 'Save Changes' : 'No changes made'}
              </Button>
            </div>
          </div>

          {/* Right side - Corrective Actions Preview */}
          <div className="w-1/2 pl-6">
            <DialogHeader>
              <div className="flex items-center justify-between">
                <DialogTitle>Notes</DialogTitle>
                <div className="flex items-center gap-2">
                  {!showAddNote && (
                    <Button variant="outline" onClick={() => setShowAddNote(true)}>Add Note</Button>
                  )}
                  <DialogClose asChild>
                    <Button variant="ghost" size="icon" aria-label="Close">
                      <span className="sr-only">Close</span>
                      <FontAwesomeIcon icon={faXmark} className="h-4 w-4" />
                    </Button>
                  </DialogClose>
                </div>
              </div>
            </DialogHeader>

            {showAddNote && (
            <div className="mt-4 space-y-3 max-h-96 overflow-y-auto pr-2">
              <Textarea
                placeholder="Add a note..."
                className="w-full"
                rows={4}
                value={newNoteText}
                onChange={(e) => setNewNoteText(e.target.value)}
              />
              <div className="flex justify-end">
                <Button disabled={processingRequest} size={'sm'} onClick={() => handleAddNote()}>Save</Button>
              </div>
            </div>
            )}

            <ScrollArea className="h-120">
            {notes?.length > 0 ? (
                notes.map((note, index) => (
                  <div key={index} className="border p-4 rounded-md mt-2">
                    <p className="text-sm whitespace-pre-wrap">{note.message}</p>
                    {note.owner == '0' ? (
                      <p className="text-xs text-muted-foreground pt-2">
                        — de.iterate system on {note.metadata.created_at.toLocaleString()}
                      </p>
                    ) : (
                      <>
                        <p className="text-xs text-muted-foreground pt-2">
                          — {userIdToName[note.owner] ?? 'Unknown or Deleted'} on {note.metadata.created_at.toLocaleString()}
                        </p>

                        <div className="flex justify-end">
                          <AlertDialog>
                            <AlertDialogTrigger asChild>
                              <Button
                                disabled={processingRequest}
                                className="mt-2"
                                variant="destructive"
                                size="xs"
                              >
                                Remove
                              </Button>
                            </AlertDialogTrigger>

                            <AlertDialogContent className="bg-white">
                              <AlertDialogHeader>
                                <AlertDialogTitle>Are you sure?</AlertDialogTitle>
                                <AlertDialogDescription>
                                  This will permanently remove the note. This action cannot be undone.
                                </AlertDialogDescription>
                              </AlertDialogHeader>
                              <AlertDialogFooter>
                                <AlertDialogCancel>Cancel</AlertDialogCancel>
                                <AlertDialogAction asChild>
                                  <Button
                                    variant="destructive"
                                    className="bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60"
                                    onClick={async () => {
                                      console.log(note);
                                      await handleDeleteNote(note);
                                    }}
                                  >
                                    Delete
                                  </Button>
                                </AlertDialogAction>
                              </AlertDialogFooter>
                            </AlertDialogContent>
                          </AlertDialog>
                        </div>
                      </>
                    )}
                  </div>
                ))
              ) : (
              <div className="mt-8 text-center text-muted-foreground">
                <p>No current notes</p>
              </div>
            )}
            </ScrollArea>



          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
};

interface PrivacyRequestEditItemProps {
  isOpen: boolean;
  onClose: () => void;
  item: PrivacyRequestsItem;
}
const PrivacyRequestEditDialog: React.FC<PrivacyRequestEditItemProps> = ({ isOpen, onClose, item }: PrivacyRequestEditItemProps)=> {
  const { isDark, primaryColor, accentColor } = useTheme();

  const [formState, setFormState] = useState<PrivacyRequestsItem>({
    ...item,
  });

  const [formErrors, setFormErrors] = useState({
    name: null,
    email: null,
    phoneNumber: null,
    typeOfRequest: null,
  });

  useEffect(() => {
    if(isOpen && item)
      setFormState({ ...item });
  }, [isOpen, item]);

  return (
    <Dialog>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-foreground">Edit Privacy Request</DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-3 items-center gap-4">
          <Label htmlFor="policy-name" className="text-right text-sm font-medium text-foreground">Name</Label>
          <Input
            id="policy-name"
            value={formState.name}
            // onChange={(e) => handleChange('policy_name', e.target.value)}
            required
            readOnly
            className={`col-span-2 border rounded-md focus:ring-1
              ${formErrors.name
              ? 'border-red-500 ring-red-500 focus:border-red-500 focus:ring-red-500'
              : isDark ? 'border-border focus:border-primary focus:ring-primary' : 'border-gray-200 focus:border-primary focus:ring-primary'
            }`}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}

const PrivacyRegister = () => {
  const { activeTenancy, userIdToName } = useTenancy();
  const { user } = useUser();
  const activeUser = user[0]; // for some reason, the useUser.user returns an array

  const tenancyId = activeTenancy?.id || window.companyID;

  const [uid, setUid] = useState<string | null>(isAuthLoaded() ? getAuthUID() : null);

  const [privacyRequests, setPrivacyRequests] = useState([]);
  const [privacyRequestsFiltered, setPrivacyRequestsFiltered] = useState([]);
  const [toggledRow, setToggledRow] = useState<number[]>([]);

  // Side Bar
  const [currentSideBarItem, setCurrentSideBarItem] = useState<PrivacyRequestsItem>(null);
  const [sideBarOpen, setSideBarOpen] = useState(false);
  const [processingRequest, setProcessingRequest] = useState(false);

  // New Item Dialog
  const [newItemOpen, setNewItemOpen] = useState(false);

  const [editItemOpen, setEditItemOpen] = useState(false);
  const [selectedEditItem, setSelectedEditItem] = useState<PrivacyRequestsItem>(null);

  const [viewItemDialog, setViewItemDialog] = useState<boolean>(false);
  const { id: routePrivacyId } = useParams<{ id?: string }>();

  // Search/Filter Terms + State
  const [filteredItems, setFilteredItems] = useState<PrivacyRequestsItem[]>([]);
  const [filterSearch, setFilterSearch] = useState<string>('')
  const [filterStatus, setFilterStatus] = useState<string>('')
  const [filterAvailableStatusFilters, setFilterAvailableStatusFilters] = useState<string[]>([]); // Use for the status dropdown filter

  // Tour state
  const { setSteps, isTourCompleted, setTourPage } = useTour();
  const [openTour, setOpenTour] = useState(false);

  const computeSearch = () => {
    const lowerSearch = filterSearch.toLowerCase().trim();

    const results = privacyRequests.filter((item) => {
      const matchesSearch = lowerSearch === '' || (
        item.name?.toLowerCase().includes(lowerSearch) ||
        item.email?.toLowerCase().includes(lowerSearch) ||
        item.phoneNumber?.toLowerCase().includes(lowerSearch)
      );

      const matchesStatus = filterStatus === '' || item.status === filterStatus;

      return matchesSearch && matchesStatus;
    });

    console.log('matchesStatus', privacyRequests, results);
    setFilteredItems(results);
  };

  const onActions = {
    addNote: (note) => {
      setProcessingRequest(true);
      console.log(activeTenancy.id, currentSideBarItem, {
        body: note,
        metadata: {
          date: FirebaseTimestamp.fromDate(new Date()),
          author: {
            id: uid,
            name: userIdToName[uid],
          }
        }
      });
      addPrivacyRequestNote(activeTenancy.id, currentSideBarItem, {
        body: note,
        metadata: {
          date: FirebaseTimestamp.fromDate(new Date()),
          author: {
            id: uid,
            name: userIdToName[uid],
          }
        }
      });
      getPrivacyRequestList(tenancyId).then((data) => {
        setPrivacyRequests(data);
        if (currentSideBarItem) {
          const updated = data.find((item) => item.id === currentSideBarItem.id);
          if (updated) setCurrentSideBarItem(updated);
        }
        setProcessingRequest(false);
      });
    },
    deleteNote: (item: PrivacyRequestsItem, note: PrivacyRequestNote) => {
      setProcessingRequest(true);
      console.log(activeTenancy.id, item, note);
      delPrivacyRequestNote(activeTenancy.id, item, note);
      getPrivacyRequestList(tenancyId).then((data) => {
        setPrivacyRequests(data);
        if (currentSideBarItem) {
          const updated = data.find((item) => item.id === currentSideBarItem.id);
          if (updated) setCurrentSideBarItem(updated);
        }
        setProcessingRequest(false);
      });
    },
    deleteItem: (item: PrivacyRequestsItem) => {
      const handleDeleteItem = async (item: PrivacyRequestsItem) => {
        console.log('[PRT]', 'handleDeleteItem', activeTenancy, item);
        await deletePrivacyRequestItem(activeTenancy, item);
      }
    },
  };

  const handleDeleteItem = async (item: PrivacyRequestsItem) => {
    console.log('[PRT]', 'handleDeleteItem', activeTenancy, item);
    await removeRequest(activeTenancy.id, item.id);

    reloadPrivacyRequestItems();
  }

  const computeBadgeClass = (status: string) => {
    switch (status.toLowerCase()) {
      case 'open': return 'database';
      case 'active': return 'procedure';
      case 'completed': return 'success';
      case 'closed': return 'deleted';
      default: return 'code';
    }
  }

  const computeAvailableStatuses = (status: string) => {
    switch (status.toLowerCase()) {
      case 'open': return [
        { display: 'Accept', value: 'Active' },
        { display: 'Close', value: 'Closed' },
      ];

      case 'active': return [
        { display: 'Close', value: 'Closed' },
      ];

      case 'completed':
      case 'closed': return [
        { display: 'Re-open', value: 'Open' },
      ];
    }
  };

  const [helpContent, setHelpContent] = useState(null);
  useEffect(() => {
    getHelpContentByPage('privacy.requests').then(setHelpContent);
  }, []);

  // Deep-link: open view dialog when route param is provided
  useEffect(() => {
    const rid = String(routePrivacyId || '').trim();
    if (!rid || !Array.isArray(privacyRequests) || privacyRequests.length === 0) return;
    const match = privacyRequests.find((p: any) => String(p.id) === rid);
    if (match) {
      setSelectedEditItem(match);
      setViewItemDialog(true);
    }
  }, [routePrivacyId, privacyRequests]);

  const reloadPrivacyRequestItems = () => {
    readRequest(activeTenancy.id).then((data) => {
      setPrivacyRequests(data);
      setFilteredItems(data);

      const uniqueStatuses = Array.from(
        new Set(data.map((request) => request.status).filter(Boolean))
      );
      setFilterAvailableStatusFilters(uniqueStatuses);

    });
    // getPrivacyRequestList(activeTenancy.id).then((data) => {
    //   setPrivacyRequests(data);
    //   setFilteredItems(data);
    // })
  };

  // Button style for active filter
  const getFilterButtonClass = (active: boolean) =>
    active
      ? 'filter-btn-active border font-semibold bg-primary-fade text-[color:var(--primary)] border-primary-fade-border'
      : 'border border-border bg-transparent text-foreground';

  useEffect(() => {
    computeSearch();
  }, [filterStatus, filterSearch]);

  useEffect(() => {
    if (!activeTenancy.id) return;
    console.log('asd', userIdToName['0tPhJyhduNdZOMf4JWXaM8fDbIs1']);

    readRequest(activeTenancy.id).then((data) => {
      console.log('asd', data);
      setPrivacyRequests(data);
      setFilteredItems(data);

      const uniqueStatuses = Array.from(
          new Set(data.map((request) => request.status).filter(Boolean))
        );
      setFilterAvailableStatusFilters(uniqueStatuses);

    });
  }, [activeTenancy]);

  // Tour implementation
  useEffect(() => {
    setTourPage('privacy-requests');
  }, [setTourPage]);

  // Tour configuration for Privacy Requests
  useEffect(() => {
    const steps: any[] = [
      {
        content: (
          <div>
            <h3 className="font-semibold text-lg mb-2">Data Privacy Requests</h3>
            <p>This is your data privacy requests page. It shows you all the data privacy requests in your tenant.</p>
          </div>
        ),
        selectorId: TOUR_STEP_IDS.PRIVACY_REQUESTS_PAGE,
        position: "bottom" as const,
      }
    ];

    // Search Bar step
    steps.push({
      content: (
        <div>
          <h3 className="font-semibold text-lg mb-2">Search Bar</h3>
          <p>This will search for data privacy requests.</p>
        </div>
      ),
      selectorId: TOUR_STEP_IDS.PRIVACY_REQUESTS_SEARCH_BAR,
      position: "bottom" as const,
    });

    // Add Request button
    steps.push({
      content: (
        <div>
          <h3 className="font-semibold text-lg mb-2">Add Request</h3>
          <p>This will open the add data privacy request modal.</p>
        </div>
      ),
      selectorId: TOUR_STEP_IDS.ADD_PRIVACY_REQUEST_BUTTON,
      position: "left" as const,
    });

    // Filter buttons
    steps.push({
      content: (
        <div>
          <h3 className="font-semibold text-lg mb-2">Filter buttons</h3>
          <p>This will filter the data privacy requests to show all requests or only your requests.</p>
        </div>
      ),
      selectorId: TOUR_STEP_IDS.PRIVACY_REQUESTS_FILTER_BUTTONS,
      position: "bottom" as const,
    });

    // Sorting buttons
    steps.push({
      content: (
        <div>
          <h3 className="font-semibold text-lg mb-2">Sort Table</h3>
          <p>This will sort the data privacy requests by selected column.</p>
        </div>
      ),
      selectorId: TOUR_STEP_IDS.PRIVACY_REQUESTS_SORTING_BUTTONS,
      position: "bottom" as const,
    });

    // Table action buttons
    steps.push({
      content: (
        <div>
          <h3 className="font-semibold text-lg mb-2">Table action buttons</h3>
          <p>View: This will open the view data privacy request modal.<br/>Delete: This will delete the data privacy request.</p>
        </div>
      ),
      selectorId: TOUR_STEP_IDS.PRIVACY_REQUESTS_ACTION_BUTTONS,
      position: "left" as const,
    });

    // Results per page
    steps.push({
      content: (
        <div>
          <h3 className="font-semibold text-lg mb-2">Per page</h3>
          <p>This will change the number of results per page.</p>
        </div>
      ),
      selectorId: TOUR_STEP_IDS.PRIVACY_REQUESTS_RESULTS_SELECTOR,
      position: "left" as const,
    });

    // Add columns button
    steps.push({
      content: (
        <div>
          <h3 className="font-semibold text-lg mb-2">Add Columns Button</h3>
          <p>This will add a column of your choosing to the table.</p>
        </div>
      ),
      selectorId: TOUR_STEP_IDS.PRIVACY_REQUESTS_MANAGE_COLUMNS,
      position: "left" as const,
    });

    console.log('Privacy Requests tour steps:', steps.length);
    setSteps(steps);

    // Auto-start tour if not completed
    if (!isTourCompleted && privacyRequests.length > 0) {
      setOpenTour(true);
    }
  }, [setSteps, isTourCompleted, setTourPage, privacyRequests]);

  return (
    <div id={TOUR_STEP_IDS.PRIVACY_REQUESTS_PAGE} className="page-container">
      <div className="glass-card">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
          <div>
            <h2 className="title flex flex-row">
              Privacy Request Tracker
              <span className="bg-transparent pl-2 rounded font-semibold text-center">
              </span>
            </h2>
            {/*<p className="subtitle">*/}
            {/*  This is your central command centre for managing*/}
            {/*  risk, allowing you to log, assign, link, monitor and*/}
            {/*  maintain risk to your organisation.*/}
            {/*</p>*/}
          </div>
          <div className="flex flex-wrap gap-2 md:gap-3 md:flex-nowrap">
            <Button id={TOUR_STEP_IDS.ADD_PRIVACY_REQUEST_BUTTON} className="primary-btn"  size="sm" onClick={() => {setNewItemOpen(true)}} style={{ background: 'var(--primary)', color: 'var(--primary-foreground)' }}>
              <Plus className="mr-2 h-4 w-4" /> Add Request
            </Button>
          </div>
        </div>
        {privacyRequests.length == 0 && (
          <div className="flex flex-col items-center justify-center h-64 text-muted-foreground text-center">
            <p className="text-lg font-medium">No Requests</p>
            <p className="text-sm">There are currently no privacy requests to display. You can create one by using the 'Add Request' at the top of this page.</p>
          </div>
        )}

        {privacyRequests.length > 0 && (
          <div className="filters-row flex flex-col md:flex-row md:items-center md:gap-4 md:justify-between my-5">
            <div id={TOUR_STEP_IDS.PRIVACY_REQUESTS_SEARCH_BAR} className={`w-full md:w-auto md:max-w-xs`}>
              <Input
                className="search-bar w-120"
                placeholder="Search Requests"
                value={filterSearch}
                onChange={e => setFilterSearch(e.target.value)}
              />
            </div>
            <div id={TOUR_STEP_IDS.PRIVACY_REQUESTS_FILTER_BUTTONS} className={`filter-controls mt-0 flex flex-wrap gap-2 justify-center md:justify-end md:w-auto`}>
              <Button
                variant="outline"
                size="sm"
                className={getFilterButtonClass(filterStatus === '') + ' h-9 px-4 rounded-[var(--radius)] flex items-center gap-2'}
                onClick={() => setFilterStatus('')}
              >
                All Requests
              </Button>

              {/* Status Dropdown */}
              <Select value={filterStatus} onValueChange={value => setFilterStatus(value)}>
                <SelectTrigger className={getFilterButtonClass(filterStatus) + ' min-w-[140px] rounded-[var(--radius)] flex items-center gap-2'}>
                  <span>
                    {filterStatus ? `Status: ${filterStatus}` : 'Status'}
                  </span>
                </SelectTrigger>
                <SelectContent>
                  {filterAvailableStatusFilters.map((status) => (
                    <SelectItem value={status}>{status}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
        )}

        {privacyRequests.length > 0 && (
          <div className="asset-list">
            <PrivacyRequestEditDialog isOpen={editItemOpen} onClose={() => setEditItemOpen(false)} item={selectedEditItem} />
            <DataTable
              sortingId={TOUR_STEP_IDS.PRIVACY_REQUESTS_SORTING_BUTTONS}
              columns={getPrivacyRequestColumns({
                onEdit: (row) => {},
                onView: (row) => {
                  setSelectedEditItem(row);
                  setViewItemDialog(true)
                  console.log('[ADS]', row)
                },
                onDelete: handleDeleteItem,
                // userIdToName,
                helpData: helpContent,
              })}
              data={filteredItems}
              pageSize={10}
              onRowClick={(row) => {
                setSelectedEditItem(row);
                setViewItemDialog(true);
                console.log('[PrivacyRegister] Row clicked:', row);
              }}
            />
          </div>
        )}

        <PrivacyRegisterNewItem isOpen={newItemOpen} onClose={() => {
          setNewItemOpen(false);
          reloadPrivacyRequestItems();
        }} />

        <PrivacyItemViewItemDialog isOpen={viewItemDialog} onClose={() => {setViewItemDialog(false)}} privacyRequest={selectedEditItem} reload={reloadPrivacyRequestItems} />

      </div>
      <TourAlertDialog 
        isOpen={openTour} 
        setIsOpen={setOpenTour} 
      />
    </div>
  );
};

export default PrivacyRegister;
